<section class="page-head">
  <div>
    <p class="eyebrow">Issues</p>
    <h1>Issue stream</h1>
  </div>
</section>

<section class="filter-grid">
  <label class="filter-field search-field">
    <span>Search</span>
    <input
      class="filter-input"
      type="search"
      [ngModel]="search()"
      (ngModelChange)="search.set($event)"
      (keyup.enter)="load()"
      placeholder="Message, file, repository, developer" />
  </label>

  <div class="filter-chip-group">
    <span class="chip-group-label">Severity</span>
    <div class="chip-group-options">
      @for (severity of severities; track severity) {
        <button
          type="button"
          class="filter-chip"
          [class.selected]="isSelected(selectedSeverities, severity)"
          (click)="toggleSelection(selectedSeverities, severity)">
          {{ severity }}
        </button>
      }
    </div>
  </div>

  <div class="filter-chip-group">
    <span class="chip-group-label">Category</span>
    <div class="chip-group-options">
      @for (category of categories; track category) {
        <button
          type="button"
          class="filter-chip"
          [class.selected]="isSelected(selectedCategories, category)"
          (click)="toggleSelection(selectedCategories, category)">
          {{ category }}
        </button>
      }
    </div>
  </div>

  <div class="filter-chip-group">
    <span class="chip-group-label">Verdict</span>
    <div class="chip-group-options">
      @for (verdict of verdicts; track verdict) {
        <button
          type="button"
          class="filter-chip"
          [class.selected]="isSelected(selectedVerdicts, verdict)"
          (click)="toggleSelection(selectedVerdicts, verdict)">
          {{ verdict }}
        </button>
      }
    </div>
  </div>

  <button type="button" class="action-button" (click)="load()">Apply</button>
</section>

@if (result(); as issues) {
  <section class="list-card">
    <div class="list-meta">
      <span>{{ issues.paging.totalCount }} results</span>
      <button type="button" class="action-button secondary" (click)="load()">Refresh</button>
    </div>

    <div class="issue-list">
      @for (issue of issues.items; track issue.id) {
        <article class="issue-item" [class.expanded]="expandedIssueId() === issue.id">
          <button type="button" class="issue-summary" (click)="toggle(issue.id)">
            <div class="issue-head">
              <div class="chip-row">
                <app-status-chip kind="severity" [value]="issue.severity"></app-status-chip>
                <app-status-chip kind="category" [value]="issue.category"></app-status-chip>
                <app-status-chip kind="verdict" [value]="issue.verdict"></app-status-chip>
              </div>
              <span class="review-date">{{ issue.reviewCompletedAt | localDate:'short' }}</span>
            </div>

            <div class="issue-title">{{ issue.message }}</div>
            <div class="issue-meta">
              <span>{{ issue.repositoryName }}</span>
              <span>{{ issue.developerName }}</span>
              <span>{{ issue.filePath }}:{{ issue.lineNumber }}</span>
            </div>
          </button>

          @if (expandedIssueId() === issue.id) {
            <div class="issue-details">
              <div>
                <p class="detail-label">Impact</p>
                <p>{{ issue.impact }}</p>
              </div>
              <div>
                <p class="detail-label">Suggestion</p>
                <p>{{ issue.suggestion }}</p>
              </div>
              @if (issue.exampleFix) {
                <div>
                  <p class="detail-label">Example Fix</p>
                  <pre>{{ issue.exampleFix }}</pre>
                </div>
              }
              <a [href]="issue.pullRequestUrl" target="_blank" rel="noopener">Open pull request</a>
            </div>
          }
        </article>
      }
    </div>
  </section>
} @else if (loading()) {
  <section class="state-card">Loading issues…</section>
} @else if (error()) {
  <section class="state-card error">
    <p>{{ error() }}</p>
    <button type="button" class="action-button secondary" (click)="load()">Try again</button>
  </section>
} @else {
  <section class="state-card">
    <p>No issues matched the current filters.</p>
  </section>
}
